import 'maxgraph-examples-shared/css/all.css';
import {initializeHtmlAndGraph} from 'maxgraph-examples-shared';

initializeHtmlAndGraph('#app', {toolName: 'Farm', toolUrl: 'https://www.farmfe.org/'})
